export default __webpack_public_path__ + "static/media/harvest-token-id.0b26d5ad.png";